"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Names = exports.Name = exports.Info = exports.Brand = void 0;
var _mui = require("@ori-ui/mui");
var _common = require("../../../common");
const Root = exports.Root = (0, _mui.styled)('a')(({
  theme
}) => ({
  alignItems: 'center',
  background: theme.palette.grey[100],
  borderRadius: '10px',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'row',
  fontFamily: _common.FONT_SANS_ORI,
  gap: theme.spacing(2),
  maxWidth: 450,
  overflow: 'hidden',
  padding: theme.spacing(2),
  position: 'relative',
  '&:hover': {
    color: theme.palette.text.primary,
    background: theme.palette.grey[200]
  },
  '&:focus': {
    color: theme.palette.text.primary,
    outline: `1px solid ${theme.palette.default.dark}`
  }
}));
const Names = exports.Names = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  '&:empty': {
    display: 'none'
  }
}));
const Brand = exports.Brand = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: '-webkit-box',
  fontSize: '1rem',
  fontWeight: theme.typography.fontWeightBold,
  letterSpacing: '2px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textTransform: 'uppercase',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1
}));
const Name = exports.Name = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: '-webkit-box',
  fontWeight: theme.typography.fontWeightBold,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2
}));
const Info = exports.Info = (0, _mui.styled)('div')(({
  theme
}) => ({
  color: theme.palette.text.primary,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  overflow: 'hidden',
  width: '100%'
}));
//# sourceMappingURL=root.js.map